export default {
  computed: {
    permissions() {
      return this.$route.meta.buttons;
    },
  },
};
